module.exports = __webpack_public_path__ + "img/germinal.b87d07da.png";